export const CurrentChapterIndicator = () => (
    <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 -rotate-45 w-4 h-4 bg-main-gradient p-0.5 rounded-tr-sm before:w-full before:h-full before:block before:bg-chapters-bg"></div>
);
